Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyLinkQuestionTemplate = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'items': [
          {
            'items': [
              {
                'tag': 'input',
                'attributes': {
                  'type': 'button',
                  'class': 'btn i18nResource btn-secondary',
                  'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                  'id': 'LinkQuestionCancelButton',
                },
              },
              {
                'tag': 'input',
                'attributes': {
                  'type': 'button',
                  'class': 'btn i18nResource',
                  'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                  'id': 'LinkQuestionSaveButton',
                  'style': 'float:right;',
                },
              },
              {
                'tag': 'div'
              }
            ],
            'attributes': {
              'class': 'buttonGroup standard-form-buttons',
            },
          },
          {
            'attributes': {
              'class': 'monetInlineAlerContainer',
            },
          },
          {
            'items': [
              {
                'html': Monet.I18n.getResourcesByKey('survey.link.label'),
                'attributes': {
                  'class': 'linkText',
                },
              },
              {
                'tag': 'select',
                'attributes': {
                  'id': 'LinkQuestionSelect',
                },
              },
            ],
            'attributes': {
              'class': 'questionContent',
            },
          },
        ],
        'attributes': {
          'class': 'formContent',
        },
      },
    ],
  }).render();
};
